/*@ngInject*/
const OpenSubmissionRepository = function (baseSharedPromiseRepository) {
    var sharedPromiseCache = {};

    angular.extend(this, baseSharedPromiseRepository);

    this.getGETSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.openSubmission = function (submissionId) {
        var url = '/rest/Submission/' + submissionId,
            config = {
                params: {
                    registrationIdentifier: '/Submission/' + submissionId
                }
            },
            cacheKey = submissionId;

        return this.get(cacheKey, url, config);
    };
};

angular.module('gw-um-submission')
    .service('openSubmissionRepository', OpenSubmissionRepository);
